export function Home() {
  return (
    <div class="app narrow">
      <header class="top"><div><h1>Simulador Legislativo</h1><p class="sub">Votación parlamentaria con las reglas de tu organización.</p></div></header>
      <div class="panel">
        <a class="btn primary" href="/legislador">Soy legislador: votar</a>
        <a class="btn" href="/acceso">Presidencia, secretaría y administración</a>
      </div>
    </div>
  );
}
